import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=aa73fc9a&lang=pug&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa73fc9a')) {
      api.createRecord('aa73fc9a', component.options)
    } else {
      api.reload('aa73fc9a', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=aa73fc9a&lang=pug&", function () {
      api.rerender('aa73fc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Page.vue"
export default component.exports